export default "__VITE_ASSET__DzwszS96__"